import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { ButtonItem } from '../../button/button.model';
import { Observable } from 'rxjs/Observable';
import { ButtonFactoryService } from '../../button/button-factory.service';

@Injectable()
export class ViewLottableService {

  public errorMsg: string = '';
  public displayMode: string = 'V';
  public finalizedFlag: any;
  public selectedLineItemFinalizedFlag: any;
  public buttonArray = [];
  /* to determine view lottable function is called from which screen whether from inv adjustment or from ucc  adjustment.
   same view lottable poup is used in both the screen. but access privilege of edit lottable button is diffrent */
  public tableId: string;

  constructor(protected http$: HttpClient,
    protected alertService: AlertService,
    protected resourceService: ResourceService,
    protected buttonFactoryService: ButtonFactoryService) {
  }

  public initializeButtonPanel() {
    // JIRA-LFWM 855 There is no need of buttons in view lottables of finalized Adjustment or finalized Line item
    if (this.finalizedFlag === 'Y' || this.selectedLineItemFinalizedFlag === 'Y') {
      this.buttonArray = [];
    } else {
      if (this.displayMode === 'E') {
        this.buttonArray = [
          new ButtonItem('Save', this.resourceService.get('btn_save'), '', 'icon_save.svg', []),
        ];
      } else if (this.displayMode === 'V') {
        if (this.tableId === 'adjtd') {
          this.buttonArray = [
            new ButtonItem('Edit', this.resourceService.get('btn_edit'), 'invadj_dtl_edit_ltbl', 'icon_edit.svg', [])
          ];
        } else {
          this.buttonArray = [
            new ButtonItem('Edit', this.resourceService.get('btn_edit'), 'uccadj_edit_ltbl', 'icon_edit.svg', [])
          ];
        }
      }
    }
    // enabling the buttons based on user privilege
    if (this.buttonArray.length !== 0) {
      this.buttonArray = this.buttonFactoryService.loadButtonsByPrivilege(this.buttonArray);
    }
  }


  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  /* API call to fetch lottable labels based on storerkey & commodity
  */
  public getViewLottableDynamicLabels(storerKey: string, commodity: string, tableId: any): Observable<any> {
    // LFWM-3191- adding tableId.
    const response$ = this.http$.get(`api/inventory/adjustment/` + storerKey + `/` + commodity + `/` + tableId + `/lottables/label`)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.errors.length !== 0) {
          if (error.error.errors[0].validationCode !== 200) {
            return Observable.throw(error.error.errors['0'].validationMessage);
          }
        }
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  // LFWM-3559 service call for recalculate lottables
  public lottableReCalculate(request): Observable<Response> {
   return this.http$.post(`api/asn/lottable/recalculate`, JSON.stringify(request))
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/viewlottables-lookup/viewlottables-lookup.service.ts